/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from "react";
import dotenv from "dotenv";
import ReactDOM from "react-dom";

import App from "./App";

dotenv.config({ path: `${__dirname}/.env.${process.env.NODE_ENV}` });

ReactDOM.render(<App />, document.getElementById("root"));
